import { Map as TXTMap } from './txt';

export class SchoolityMap {
  static TXT = TXTMap;
}

export type { Types as SchoolityTXTTypes } from './txt';